import React from 'react'
import Honeybadger from 'honeybadger-js'

// GraphQL
import { useMutation } from '@apollo/client'
import mutation from './mutation.graphql'

const withMutation = WrappedComponent => {
  return props => {
    const {
      camper, // via graphql query
      notify, // via redux actions
      setLoggedIn, // via withState
      setErrorMessage // via redux actions
    } = props

    // TODO: use shared mutation error handling?
    const handleMutationError = error => {
      notify({
        variant: 'error',
        autoHide: false,
        message: 'Log in failed. Please try again or refresh.'
      })
      Honeybadger.notify(error, {
        name: 'CamperLogInError',
        context: { camper }
      })
    }

    const handleMutationCompleted = data => {
      // when data is returned:
      if (data && data.logInCamper) {
        // display any mutation errors
        if (data.logInCamper.errors.length > 0) {
          const message = data.logInCamper.errors
            .map(error => error.message)
            .join(', ')
          setErrorMessage(message)
        } else {
          setLoggedIn(true)
          window.location.pathname = '/virtual/activities'
        }
      }
    }

    // setup GraphQL mutation
    const [logInCamper, { loading }] = useMutation(mutation, {
      onCompleted: handleMutationCompleted,
      onError: handleMutationError
    })

    return (
      <WrappedComponent
        loading={loading}
        logInCamper={logInCamper}
        {...props}
      />
    )
  }
}

export default withMutation
